import SocialLinks from './social-links.js';

export default SocialLinks;
